import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class CompetitionsApi extends BaseApiService {
  url(params: BaseApiRequestParams) {
    const route = this.root + params.toString();

    return route;
  }
}
